import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de6746f22b099e/node_modules/next/dist/client/link.js");
